"use client";

import React, { useState } from "react";
import Image from "next/image";

const chartData = [
  { value: 30, date: "Jan 22", change: "+300" },
  { value: 45, date: "Jan 24", change: "+450" },
  { value: 25, date: "Jan 26", change: "+250" },
  { value: 50, date: "Jan 28", change: "+500" },
  { value: 38, date: "Jan 30", change: "+380" },
  { value: 65, date: "Feb 1",  change: "+650" },
  { value: 45, date: "Feb 3",  change: "+450" },
  { value: 85, date: "Feb 5",  change: "+850" },
  { value: 55, date: "Feb 6",  change: "+550" },
  { value: 40, date: "Feb 6",  change: "+400" },
  { value: 50, date: "Feb 6",  change: "+500" },
  { value: 68, date: "Feb 6",  change: "+680" },
  { value: 72, date: "Feb 7",  change: "+923" }, // Peak active dashboard column
  { value: 48, date: "Feb 9",  change: "+480" },
  { value: 60, date: "Feb 11", change: "+600" },
  { value: 75, date: "Feb 13", change: "+750" },
  { value: 45, date: "Feb 15", change: "+450" },
  { value: 60, date: "Feb 17", change: "+600" },
  { value: 80, date: "Mar 2",  change: "+800" },
];

const integrations = [
  { name: "GitHub", id: "repo: codeqlik", color: "#fff", icon: "G" },
  { name: "Slack", id: "channel: alerts", color: "#4A154B", icon: "S" },
  { name: "Vercel", id: "project: prod", color: "#fff", icon: "▲" },
  { name: "AWS", id: "iam: codeqlik-dev", color: "#FF9900", icon: "A" },
  { name: "Docker", id: "registry: main", color: "#2496ED", icon: "D" },
  { name: "Jira", id: "board: CQ-s1", color: "#0052CC", icon: "J" },
  { name: "Slack", id: "channel: status", color: "#4A154B", icon: "S" },
];

export default function BannerDashboard() {
  const activeBarIndex = 12;
  const [hoveredBarIndex, setHoveredBarIndex] = useState(null);

  return (
    <div className="bs-wrapper" aria-hidden="true">
      {/* ── FLOATING TWITTER CARD ─────────────────────────── */}
      <div className="bs-float bs-float-left">
        <div className="bsf-row bsf-header">
          <span className="bsf-cal-lbl">
              Enterprise Suite Running
          </span>
        </div>
        <div className="bsf-row bsf-body">
          <div className="bsf-thumb">
            <Image
              src="/assets/img/team_img.png"
              alt="Developer avatar"
              width={32}
              height={32}
              priority
              fetchPriority="high"
              className="object-cover w-full h-full"
            />
          </div>
          <div>
            <div className="bsf-title">Cloud Deployment Active</div>
          </div>
        </div>
        <div className="bsf-footer">
          <span>ERP: Odoo Enterprise</span>
          <span>users: 128 active</span>
        </div>
      </div>

      {/* ── FLOATING TODO CARD ───────────────────────────── */}
      <div className="bs-float bs-float-right">
        <div className="bsf-row bsf-header">
          <div>
            <div className="bsf-title">Enterprise Tasks</div>
            <div className="bsf-sub">ODOO-512</div>
          </div>
          <span className="bsf-arrow">↗</span>
        </div>
        <div className="bstd-task done">
          <div className="bstd-name">Configure </div>
          <span className="bstd-check">✓</span>
        </div>
        <div className="bstd-task">
          <div className="bstd-name">Activate HR Workflow</div>
          <span className="bstd-check" style={{ color: 'rgba(255,255,255,0.3)' }}>○</span>
        </div>
        <div className="bsf-row bsf-todo-time">
          <span>Deadline &nbsp;Deployment   Live</span>
          <span>⏱️</span>
        </div>
      </div>

      {/* ── DOUBLE-BORDER OUTER FRAME ─────────────────────── */}
      <div className="bs-dashboard-outer">
        {/* Phone Buttons (volume and power keys) - visible only on mobile */}
        <div className="bs-phone-btn-volume" />
        <div className="bs-phone-btn-power" />

        <div className="bs-dashboard-screen">
          <div className="bs-dashboard">
          {/* LEFT SIDEBAR */}
          <aside className="bs-sidebar">
            <div className="bs-sb-logo">Q</div>
            <div className="bs-sb-divider" />
            
            <div className="bs-sb-btn active">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <div className="bs-sb-btn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
                <polyline points="16 7 22 7 22 13" />
              </svg>
            </div>
            <div className="bs-sb-btn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <div className="bs-sb-btn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
            </div>
            <div className="bs-sb-btn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="3" />
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
              </svg>
            </div>
            <div className="bs-sb-btn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
              </svg>
            </div>
          </aside>

          {/* MAIN BODY */}
          <main className="bs-body">
            {/* TOP HEADER */}
            <div className="bs-header">
              <div className="bs-header-left">
                <div className="bs-h-title-container">
                  <div className="bs-h-title">Welcome back, John</div>
                  <div className="bs-h-sub">Statistics overview</div>
                </div>
              </div>
              <div className="bs-h-actions">
                <div className="bs-search">
                  <svg className="bs-search-ico" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="11" cy="11" r="6" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M21 21l-4.35-4.35" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className="bs-search-text">Search...</span>
                </div>
                <button className="bs-ico-btn bs-bell-btn" aria-label="Notifications">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
                    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
                  </svg>
                </button>
                <button className="bs-ico-btn bs-mail-btn" aria-label="Messages">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <rect width="20" height="14" x="2" y="5" rx="2" />
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                  </svg>
                </button>
                <div className="bs-avatar">
                  <Image
                    src="/assets/img/download2.jpeg"
                    alt="Avatar"
                    width={28}
                    height={28}
                    className="object-cover w-full h-full"
                  />
                </div>
              </div>
            </div>
            <div className="bs-divider" />

            {/* FILTER BAR */}
            <div className="bs-filter-bar">
              <button className="bs-filter-btn">This week ▾</button>
              <span className="bs-updated">Last updated at 10:22 AM</span>
            </div>

            {/* TWO-COLUMN GRID: MAIN CONTENT LEFT | INTEGRATIONS RIGHT */}
            <div className="bs-mid-grid">

              {/* LEFT COLUMN: METRICS ROW + DAILY VISITORS CHART */}
              <div className="bs-left-col">
                {/* 3 Metrics Cards side-by-side */}
                <div className="bs-metrics-row">
                  {[
                    { label: "Total builds", value: "1,324", unit: "Builds", badge: "10% ↗", ico: "⚙️" },
                    { label: "API requests", value: "12.1M", unit: "Calls", badge: "5% ↗", ico: "⚡" },
                    { label: "Build success rate", value: "98.4%", unit: "percent", badge: "1.2% ↗", ico: "✓" },
                  ].map((m, i) => (
                    <div key={i} className="bs-metric-card">
                      <div className="bs-mc-top">
                        <span className="bs-mc-label">{m.label}</span>
                        <span className="bs-mc-badge">{m.badge}</span>
                      </div>
                      <div className="bs-mc-bottom">
                        <span className="bs-mc-value">
                          {m.value} <span className="bs-mc-unit">{m.unit}</span>
                        </span>
                        <span className="bs-mc-ico">{m.ico}</span>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Daily Visitors Chart (directly underneath metrics) */}
                <div className="bs-chart-panel">
                  <div className="bs-panel-header">
                    <span className="bs-panel-title">Daily API Requests</span>
                    <span className="bs-panel-dots">•••</span>
                  </div>
                  <div className="bs-chart-area">
                    {chartData.map((bar, i) => {
                      const isCurrentlyActive = i === hoveredBarIndex || (hoveredBarIndex === null && i === activeBarIndex);
                      return (
                        <div
                          key={i}
                          className={`bs-bar-col ${isCurrentlyActive ? "active" : ""}`}
                          onMouseEnter={() => setHoveredBarIndex(i)}
                          onMouseLeave={() => setHoveredBarIndex(null)}
                        >
                          {isCurrentlyActive && (
                            <div className="bs-tooltip">
                              <span className="bs-tt-val">{bar.change}</span>
                              <span className="bs-tt-date">{bar.date}</span>
                            </div>
                          )}
                          <div className="bs-bar-fill" style={{ height: `${bar.value}%` }} />
                        </div>
                      );
                    })}
                  </div>
                  <div className="bs-x-axis">
                    {["22", "28", "2", "8", "14"].map((l, i) => (
                      <span key={i} className="bs-x-lbl">{l}</span>
                    ))}
                  </div>
                  <div className="bs-x-axis-months">
                    <span>January</span>
                    <span>February</span>
                    <span>March</span>
                  </div>
                </div>

                {/* EXTRA PANEL IN EMPTY SPACE */}
                <div className="bs-extra-panel">
                  <div className="bs-panel-header">
                    <span className="bs-panel-title">System Performance</span>
                    <span className="bs-panel-dots">•••</span>
                  </div>
                  <div className="bs-perf-bars">
                    <div className="bs-perf-item">
                      <div className="bs-perf-info"><span style={{ color: '#fff' }}>CPU Usage</span> <span style={{ color: '#fff' }}>42%</span></div>
                      <div className="bs-perf-track">
                        <div className="bs-perf-fill" style={{ width: "42%", background: "var(--brand-color)" }} />
                      </div>
                    </div>
                    <div className="bs-perf-item">
                      <div className="bs-perf-info"><span style={{ color: '#fff' }}>Memory Allocation</span> <span style={{ color: '#fff' }}>78%</span></div>
                      <div className="bs-perf-track">
                        <div className="bs-perf-fill" style={{ width: "78%", background: "var(--brand-color)" }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* RIGHT COLUMN: INTEGRATIONS PANEL */}
              <div className="bs-right-col">
                <div className="bs-integrations">
                  <div className="bs-panel-header">
                    <span className="bs-panel-title">Integrations</span>
                    <span className="bs-panel-dots">•••</span>
                  </div>
                  <div className="bs-int-list">
                    {integrations.map((item, i) => (
                      <div key={i} className="bs-int-item">
                        <div className="bs-int-info">
                          <div className="bs-int-icon" style={{ color: item.color }}>{item.icon}</div>
                          <div>
                            <div className="bs-int-name">{item.name}</div>
                            <div className="bs-int-id">{item.id}</div>
                          </div>
                        </div>
                        <button className={`bs-int-btn ${i === 5 ? "connected" : ""}`}>
                          {i === 5 ? "Connected" : "Connect"}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </div>

          </main>
        </div>
        </div>

      </div>

    </div>
  );
}
